<template>
    <div style="background-color: #F8F9FB;">
        <hhead></hhead>
        <crm-nav></crm-nav>
        <div class="jgMsg_box" style="overflow: hidden;">
            <div class="jgMsg" :style="{
          
          boxSizing: 'border-box',
          minWidth: '1250px',
        }">
                <div @click="prev" class="prev"><span class="iconfont icon-chehui"></span>&nbsp;点击返回</div>
                <div class="listMsg"
                    style="height: auto;border: none;padding: 0;display: flex;margin-bottom: 20px;cursor: default;">

                    <!-- 投顾名称 -->
                    <div style="flex: 1;" class="tgName">
                        <div style="display: flex;flex: 1;">

                            <el-upload style="position: relative;" class="avatar-uploader"
                                :action="this.$store.state.api + '/ad/upload/upload_file'" :show-file-list="false"
                                name="file" accept="image/png, image/jpeg" :on-success="handleAvatarSuccess">
                                <img v-if="res.selfImage"
                                    :style="{width: res.type==1?'100px':'156px',height: '100px',marginRight: '20px'}"
                                    :src="this.$store.state.api + res.selfImage">
                                <img v-if="!res.selfImage && res.type==1"
                                    style="width: 156px;height: 100px;margin-right: 20px;"
                                    src="../../../../assets/images/crm/tx.jpg">
                                <img v-if="!res.selfImage && res.type==0"
                                    style="width: 156px;height: 100px;margin-right: 20px;"
                                    src="../../../../assets/images/crm/nav/jg.png">

                                <i class="el-icon-camera" style="border-radius: 50%;display: block;background-color: #5B85FF;width: 28px;height: 28px;
                      text-align: center;line-height: 28px;font-size: 17px;color: #fff;
                      position: absolute;bottom: 45px;right: 5px;border: 1px solid #fff;
                      "></i>
                            </el-upload>

                            <div style="flex: 1;position: relative;padding-left: 15px;">
                                <div class="jgName" style="margin-bottom: 20px;">
                                    <h2 v-if="edit2">{{res.simpleName}}</h2>
                                    <el-input v-if="!edit2" v-model="res.simpleName" placeholder="" />
                                    <p v-if="edit2" :style="{border:res.partner!=0?'1px solid #b541f1':'1px solid #1cbdf2',
                                    color:res.partner!=0?'#b541f1':'#1cbdf2',
                                    background:res.partner!=0?'#fbf5ff':'#f7fdff',marginRight:'10px'}">
                                        {{res.partner==0?'甲方':'乙方'}}</p>

                                    <!-- <el-switch
                                    v-if="!edit2"
                                            style="margin-top: 12px;margin-right: 10px;"
                                                v-model="partner"
                                                active-text="乙"
                                                inactive-text="甲">
                                                </el-switch> -->
                                    <div v-if="!edit2"
                                        style="width: 80px;height: 24px;display: flex;margin: 10px 10px 0 0;text-align: center;font-size: 14px;cursor: pointer;border-radius: 4px;">
                                        <li @click='jiaBtn'
                                            :style="{flex: 1,lineHeight: '24px',position: 'relative',border:partner==0?'1px solid #1cbdf2':'1px solid #94989F' ,color: partner==0?'#1cbdf2':'#94989F',backgroundColor: '#fff',borderRadius:' 4px',zIndex:partner==0?100:10}">
                                            甲方</li>
                                        <li @click='yiBtn'
                                            :style="{flex: 1,lineHeight: '24px',position: 'relative',border:partner==1?'1px solid #b541f1':'1px solid #94989F' ,color:partner==1? '#b541f1':'#94989F',marginLeft: '-5px',backgroundColor: '#fff',borderRadius: '4px',zIndex:partner==1?100:10}">
                                            乙方</li>
                                    </div>
                                    <p :style="{border:res.type!='0'?'1px solid #FFAB85':'',
                                        color:res.type!='0'?'#FFAB85':'',
                                        background:res.type!='0'?'#FFFDF8':'',}">{{res.type==0?'企业':'个人'}}</p>



                                    <p
                                        :style="{width: '50px',border: interim?'1px solid #ff4a4a':'1px solid #B5BAC3',color: interim?'#ff4a4a':'#94989F',backgroundColor:interim?'#fffafa':'#F3F5F9',textAlign: 'center',lineHeight: '23px',marginLeft: '10px',position: 'relative'}">
                                        考察期
                                        <span @click='interimBtn' v-if="!edit2&&interim"
                                            :style="{position: 'absolute',fontSize: '12px',color: '#FF4A4A',right:' -7px',top: '-11px',background: '#fff',borderRadius: '50%',width: '12px',height: '12px',cursor: 'pointer'}"
                                            class="iconfont icon-Group-"></span>
                                        <span @click='interimBtn' v-if="!edit2&&!interim"
                                            :style="{position: 'absolute',fontSize: '12px',color: '#FF4A4A',right:' -7px',top: '-11px',background: '#fff',borderRadius: '50%',width: '12px',height: '12px',cursor: 'pointer'}"
                                            class="iconfont icon-dui"></span>
                                    </p>
                                    <div class="titleBox"
                                        style="position: absolute;width: 52px;right: 0;top: 15px;right: 100px;">


                                        <i v-if="edit2" @click="editBtn" class="iconfont icon-bianji"></i>
                                        <i v-if="edit2" @click="editBtn" class="decoration">修改</i>
                                        <i v-if="!edit2" @click="saveBtn" class="iconfont icon-baocun "></i>
                                        <i v-if="!edit2" @click="saveBtn" class="decoration">保存</i>

                                    </div>

                                </div>
                                <div class="jg_Msg information"
                                    style="padding-bottom: 20px;display: flex;justify-content: space-around;padding-right: 100px;">
                                    <li class="li_input1" style="width: 180px;display: block;">
                                        <div style="display: flex;">
                                            <span>联系人：</span>
                                            <p v-if="edit2">{{res.contactor}}</p>
                                            <el-input v-if="!edit2" v-model="res.contactor" placeholder="" />
                                        </div>

                                    </li>
                                    <li class="li_input2" style="width: 250px;margin-right: 20px;display: block;">
                                        <div style="display: flex;">
                                            <span>电话：</span>
                                            <p v-if="edit2">{{res.phone}}</p>
                                            <el-input v-if="!edit2" v-model="res.phone" placeholder="" />
                                        </div>

                                    </li>

                                    <li class="li_input3" style="flex: 1;display: block;">
                                        <div style="display: flex;">
                                            <span>邮箱：</span>
                                            <p v-if="edit2">{{res.mail}}</p>
                                            <el-input v-if="!edit2" v-model="res.mail" placeholder="" />
                                        </div>

                                    </li>


                                </div>

                            </div>

                            <div style="flex: .6;display: flex;justify-content: space-between;text-align: center;">
                                <li>
                                    <div style="margin-bottom: 25px;font-size: 18px;">账号数量</div>
                                    <p style="font-size: 30px;color: #5B85FF;">{{res.accCount }}<i
                                            style="font-size: 18px;">个</i> </p>
                                </li>
                                <b style="width: 1px;height: 68px;background-color: #EAEDF2;"></b>
                                <li>
                                    <div style="margin-bottom: 25px;font-size: 18px;">累计收益</div>
                                    <p style="font-size: 30px;color: #FA4B22;">{{res.sumProfit|num1 }}<i
                                            style="font-size: 18px;">%</i></p>
                                </li>
                                <b style="width: 1px;height: 68px;background-color: #EAEDF2;"></b>
                                <li>
                                    <div style="margin-bottom: 25px;font-size: 18px;">累计分红</div>
                                    <p style="font-size: 30px;color: #FA4B22;">{{res.shareMoney|format }}<i
                                            v-if="res.shareMoney" style="font-size: 18px;">万</i></p>
                                </li>
                            </div>
                        </div>



                        <!-- <div class="jg_bottom" style="width: auto;margin-bottom: 10px;">
                            <p>联系人：{{res.contactor}}</p>
                            <p>联系电话：{{res.phone}}</p>
                            <p>{{res.type==0?'成立时间':'出生日期'}}：{{res.date|datas}}</p>
                            <p>{{res.type==0?'社会信用代码':'身份证号码'}}：{{res.certNum}}</p>
                        </div> -->

                        <!-- <div class="information">
                            <div v-if="res.type==0">
                                <span>公司简称：</span>
                                <p v-if="edit2">{{res.simpleName}}</p>
                                <el-input v-if="!edit2" v-model="res.simpleName" placeholder="" />
                            </div>
                            <div>
                                <span>联系人：</span>
                                <p v-if="edit2">{{res.contactor}}</p>
                                <el-input v-if="!edit2" v-model="res.contactor" placeholder="" />
                            </div>
                            <div>
                                <span>联系电话：</span>
                                <p v-if="edit2">{{res.phone}}</p>
                                <el-input v-if="!edit2" v-model="res.phone" placeholder="" />
                            </div>
                        </div> -->

                        <div class="titleBox">
                            <span>
                                尽调资料
                            </span>
                            <p>
                                <i v-if="edit" @click=edit_ class="iconfont icon-bianji "></i>
                                <i v-if="edit" @click=edit_ class="decoration">修改</i>
                                <i v-if="!edit" @click="saveBtn_" class="iconfont icon-baocun "></i>
                                <i v-if="!edit" @click="saveBtn_" class="decoration">保存</i>
                            </p>
                        </div>


                        <p style="margin-left: 10px;font-size: 18px;display: flex;padding: 10px 0;">尽调表附件：<a
                                v-if="res.investorInfoFile" class="iconfont icon-hetong decoration1"
                                :href="this.$store.state.api+res.investorInfoFile" target="_blank"
                                style="font-size: 18px;color: #5B85FF;cursor: pointer;">

                            </a>

                            <!-- 上传尽调表 -->
                            <el-upload class="avatar-uploader" v-if="!res.investorInfoFile" ref="my-upload"
                                :action="this.$store.state.api + '/ad/upload/upload_file'" :on-remove="delBtn__t"
                                name="file" accept=".docx,.doc" :limit=1 :on-success="handleAvatarSuccess__t">
                                <i
                                    style="color: #fff;width: 76px;height: 24px;background-color: #62DCB5;text-align: center;border-radius: 2px;display: block;font-size: 12px;line-height: 24px;">上传文件</i>
                            </el-upload>

                        </p>
                        <p style="margin-left: 10px;font-size: 18px;margin-top: 10px;" class="fwTltle">投资范围：</p>
                        <div v-if="edit"
                            style="margin-left: 10px;font-size: 18px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                            class="fw">{{res.address}}</div>
                        <div v-if="!edit" class="textareaBox">
                            <el-input type="textarea" rows="3" v-model="res.address"> </el-input>
                        </div>


                    </div>
                </div>




            </div>
        </div>
        <div class="jgMsg_box" style="padding-top: 5px;overflow: hidden;">
            <div class="jgMsg" :style="{
                
                boxSizing: 'border-box',
                minWidth: '1250px',
                
            }">
                <div class="table">
                    <div class="title">合作信息</div>
                    <el-table :header-cell-style="{textAlign: 'center'}" :data='contractList' border size="medium"
                        style="width: 100%">
                        <el-table-column prop="contractNum" label="合作编号" width="" height="48" align="center">
                        </el-table-column>
                        <el-table-column align="center" label="合作起始时间">
                            <template slot-scope="scope">
                                <span>{{scope.row.startTime|date}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cooCycle" align="center" label="合作周期">
                        </el-table-column>
                        <el-table-column width="80" align="center" label="附件">
                            <template slot-scope="scope">
                                <a :href="api + scope.row.contractFile" style="color: #3D6BF1;cursor: pointer;"
                                    class=" iconfont icon-hetong decoration"></a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shareMoney" align="right" label="累计分红">
                            <template slot-scope="scope">
                                <span>{{scope.row.shareMoney|money}}</span>
                            </template>
                        </el-table-column>
                        </el-table-column>
                        <el-table-column align="center" label="合作状态">
                            <template slot-scope="scope">
                                <span>{{scope.row.state==0?'合作中':(scope.row.state==1?'合作暂停': '合作终止')}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="table">
                    <div class="title">账户列表 </div>
                    <el-table :header-cell-style="{textAlign: 'center'}" :data='userList' border size="medium"
                        style="width: 100%">


                        <el-table-column align="center" prop="userCode" label="账户">

                        </el-table-column>
                        <el-table-column prop="userName" label="姓名" align="center">
                        </el-table-column>


                        <el-table-column prop="contractNum" align="center" label="合作编号">

                        </el-table-column>
                        <el-table-column prop="cooCycle" align="center" label="合作周期">

                        </el-table-column>


                        <el-table-column prop='capitalScaleName' align='right' width="150" label="规模范围">

                        </el-table-column>
                        <el-table-column prop='shareMoney' align='right' label="累计分红">
                            <template slot-scope="scope">
                                <span>{{scope.row.shareMoney | money}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sumNet" width="80" align='right' label="净值">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.sumNet>1?'#FA5D22':'#3ABA94'}">{{scope.row.sumNet|num3}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop='profitRate' width="90" align='right' label="累计">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.profitRate>=0?'#FA5D22':'#3ABA94'}">{{scope.row.profitRate|num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisYearProfit" width="100" align='right' label="今年来">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.thisYearProfit>=0?'#FA5D22':'#3ABA94'}">{{scope.row.thisYearProfit|num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="thisMonthProfit" width="90" align='right' label="月内">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.thisMonthProfit>=0?'#FA5D22':'#3ABA94'}">{{scope.row.thisMonthProfit|num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="yearlyProfitRate" width="90" align='right' label="年化">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.yearlyProfitRate>=0?'#FA5D22':'#3ABA94'}">{{scope.row.yearlyProfitRate|num}}</span>
                            </template>
                        </el-table-column>

                    </el-table>
                    <div style="display: flex;">
                        <div @click="adduser" class="el-icon-plus" :style="{cursor: 'pointer',background:'#fff',
                            width: '100px',
                            height: '32px',
                            textAlign: 'center',
                            boxSizing: 'border-box',
                            border: 0,
                            lineHeight: '30px',             
                            fontSize: '16px',
                            marginRight: '20px',
                            color: '#5b85ff',
                            borderRadius: '2px',
                            marginTop:'20px',
                            border:'1px solid #5b85ff',
                            boxSizing:'border-box'
                        }">添加账号</div>

                        <div @click="Investor" :style="{cursor: 'pointer',background:userList.length>0?'#5b85ff':'#C2C7CE',
                        width: '100px',
                        height: '32px',
                        textAlign: 'center',
                        boxSizing: 'border-box',
                        border: 0,
                        lineHeight: '32px',             
                        fontSize: '16px',
                        marginRight: '20px',
                        color: '#fff',
                        borderRadius: '2px',
                        marginTop:'20px'
                    }">点击分析</div>
                    </div>
                </div>

                <div class="table">
                    <div class="title">分红纪录</div>
                    <el-table :data='dividendList' border :header-cell-style="{textAlign: 'center'}" size="medium"
                        style="width: 100%">


                        <el-table-column prop="userCode" align='center' label="分红账户">

                        </el-table-column>

                        <el-table-column prop="shareTime" align='center' label="分红日期">
                        </el-table-column>

                        <el-table-column prop="shareMoney" align='right' label="金额">
                            <template slot-scope="scope">
                                <span>{{scope.row.shareMoney|money}}</span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>


            <transition name="el-fade-in-linear">
                <!--  添加遮罩层 -->
                <div class="popContainer" v-show="adduserShow">
                    <div class="add" :style="{ width: '800px',paddingBottom:'15px' }">
                        <div class="close"></div>
                        <div class="Top" :style="{ width: '800px' }">
                            添加
                        </div>
                        <span @click="closeBtn" class="close iconfont icon-close_round_fill_bold
              "></span>

                        <div class="form_box" style="width: 100%;">
                            <div class="searchUserBox searchBox">
                                <el-input v-model="userSearch" placeholder="请输入账户"></el-input>
                                <el-input v-model="nameSearch" placeholder="请输入姓名"></el-input>
                                <input class="btn" type="button" style="margin-top: 15px;" @click='searchBtn'
                                    value="搜索" />
                                <input style="color: #fff;background-color: #5B85FF;margin-top: 15px;" class="btn"
                                    @click='resetBtn' type="reset" value="重置" />
                            </div>

                            <div class="table" style="margin-top: 40px;">
                                <el-table height='400' border :data="resList" size="medium" style="width: 100%"
                                    :header-cell-style="{textAlign: 'center'}" :row-class-name="tableRowClassName">
                                    <el-table-column width="50" :render-header="renderHeader">
                                        <template slot-scope="scope">
                                            <el-checkbox @change="checkBtn(scope.row.deleted,scope.row.id)"
                                                v-model="scope.row.deleted"></el-checkbox>
                                        </template>
                                    </el-table-column>


                                    <el-table-column align='center' prop="userCode" label="账户">

                                    </el-table-column>
                                    <el-table-column prop="userName" label="姓名"
                                align='center'
                              >
                              </el-table-column>

                                    <el-table-column prop='shareMoney' align='right' label="累计分红">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.shareMoney|format}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="sumNet" width="80" align='right' label="净值">
                                        <template slot-scope="scope">
                                            <span
                                                :style="{color:scope.row.sumNet>1?'#FA5D22':'#3ABA94'}">{{scope.row.sumNet|num3}}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="simpleName" label="合作方名称" align='center'>
                                    </el-table-column>

                                    <el-table-column prop="contractNum" label="作编号"
                            align='center'
                          >
                          </el-table-column>
                                     
                              
                            
                              
                            </el-table>
                            </div>
                     



                        </div>
                        <div class="form_btn">

                            <button @click='submit'>提交</button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>


    </div>
</template>
<script>
    import hhead from '../../header/index';
    import crmNav from '../../../../components/crmNav/index';
    import './style.css';
    const echarts = require('echarts');
    export default {
        components: { hhead, crmNav },
        data() {
            return {
                MHeight: document.documentElement.clientHeight - 94 + 'px',
                api: this.$store.state.api,
                res: '',//投顾信息
                contractList: [],//合作信息
                userList: [],//账户列表
                dividendList: [],//分红记录
                activeName: '1',
                MWidth: '',
                interim: '',
                partner: '',
                option: [],
                tableList: [],
                tabL: '',
                edit2: true,
                edit: true,
                adduserShow: false,
                resList: [],
                pageLength: null, //分页长度
                page: 0,
                length: '', //账户列表总数
                arrId: [],//保存的本地ID

                logLevel: false,
                userSearch: '',//账号搜索
                nameSearch: '',
            };
        },
        filters: {
            format: function (n) {
                if (n) {

                    return Math.round(n / 10000)
                } else {
                    return '0'
                }
            },
            datas: function (date) {
                if (date) {
                    return date.substr(0, 10).replace('/', '年').replace('/', '月') + '日'
                }
            },
            num: function (n) { //数字格式化
                if (n) {

                    return (Math.round(n * 10000) / 100).toFixed(2) + '%'
                } else {
                    return '0.00'
                }
            },
            date: function (date) {
                if (date) {
                    return date.substr(0, 10).replace('/', '-').replace('/', '-')
                }
            },
            num1: function (n) { //数字格式化
                if (n) {

                    return Math.round(n * 10000) / 100
                } else {
                    return 0
                }
            },
            num3: function (n) {
                if (n) {
                    return n.toFixed(4)
                }
            },
            money: function (n) {
                if (n) {
                    return n.toFixed(2)
                } else {
                    return '0.00'
                }
            }
        },
        mounted() {

            this.queryInvestor()

            this.list()

            this.htMsg()// 查询投顾合作信息

            this.userAxios()//账户列表

            this.record()// 查询分红记录

        },
        methods: {
            htMsg() {//查询合作信息
                this.$axios.post(
                    '/crm/inverstor/queryInvCon',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        invId: this.$route.query.id
                    }
                ).then(res => {
                    // console.log(res)

                    if (res.data.code == 200) {
                        this.contractList = res.data.data
                    }
                    else {
                        // console.log(res.data.message)
                        // this.$alert(res.data.message, {
                        //     confirmButtonText: '确定',
                        //     type: 'error',
                        //     center: true
                        // }).then(() => { }
                        // ).catch(() => { });
                    }
                })
            },
            record() {//查询分红记录

                this.$axios.post(
                    '/crm/inverstor/queryInvShare',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        invId: this.$route.query.id
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.dividendList = res.data.data
                    }
                    else {
                        // console.log(res.data.message)
                        //     this.$alert(res.data.message, {
                        //         confirmButtonText: '确定',
                        //         type: 'error',
                        //         center: true
                        //     }).then(() => { }
                        //     ).catch(() => { });
                    }
                })
            },
            userAxios() {
                // 查询账户列表
                this.$axios.post(
                    '/crm/inverstor/queryInvAcc',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        invId: this.$route.query.id
                    }
                ).then(res => {
                    // console.log(res)

                    if (res.data.code == 200) {
                        this.userList = res.data.data
                    }

                })
            },
            submit() {//提交
                let id = ''
                this.resList.forEach(item => {
                    if (item.deleted) {
                        id += ',' + item.id
                    }
                })
                this.$axios.post(
                    '/crm/inverstor/addAccsOnInverstor',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        inverstorId: this.$route.query.id,
                        accs: id.replace(',', '')
                    }
                ).then(res => {
                    if (res.data.code == 200) {
                        this.userAxios()
                        this.queryInvestor()
                        this.record()
                        this.list()
                        this.htMsg()
                        this.adduserShow = false
                        this.userSearch = ''
                        this.nameSearch = ''
                        this.logLevel = false
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                    console.log(res)
                }).catch(err => {
                    console.log(err)
                })
            },
            tableRowClassName(row, index) { //表格行

                if (!row.row.isShow) {
                    return 'hidden-row'
                } else {
                    return ''
                }
            },
            searchBtn() {//搜索按钮
                this.resList.forEach(item => {

                    if (item.userCode.indexOf(this.userSearch + '') != -1 && item.userName.indexOf(this.nameSearch + '') != -1) {
                        item.isShow = true
                    } else {
                        item.isShow = false
                    }
                })
            },
            resetBtn() {// 重置按钮
                this.userSearch = ''
                this.nameSearch = ''
                this.searchBtn()
            },
            jiaBtn() {
                this.partner = 0
            },
            yiBtn() {
                this.partner = 1
            },
            interimBtn() {
                this.interim = !this.interim
            },
            closeBtn() { //取消
                this.adduserShow = false
                this.arrId = []
                this.logLevel = false
                this.list()
            },
            select(checked) {
                // 如果checked为true则是勾选了对应的表头
                //   console.log(checked)
                this.logLevel = checked
                if (this.logLevel) { //全选

                    this.resList.forEach((item, index) => {
                        item.deleted = true
                        // if(item.deleted == false){  //判断全选之前没有选中的
                        //     this.arrId.push(item.id) //没有选中的ID push到arrId数组
                        // } 
                    })

                } else {  //全不选
                    this.resList.forEach(item => {
                        item.deleted = false
                        // this.arrId.forEach((e,i)=>{ //从arrId数组里删除未选中的ID
                        //     if(e == item.id){
                        //         this.arrId.splice(i,1)
                        //     }
                        // })
                    })

                }
                //   console.log(this.arrId)
            },
            renderHeader(h, { column }) {
                return (
                    'span',
                    [
                        h('el-checkbox', {
                            on: {
                                change: this.select
                            },
                            props: {
                                value: this.logLevel //文字框的内容取决于这个value，如果value不存在，会报错
                            }
                        }),
                        h('span', column.label)
                    ]
                )
            },
            checkBtn(e, id) {

                if (e) {
                    let i = 0
                    this.resList.forEach(item => {
                        if (item.deleted) {
                            i++
                        }
                    })
                    if (i == this.resList.length) {

                        this.logLevel = true
                    }

                    this.arrId.push(id)
                } else {
                    this.logLevel = false
                    this.arrId.forEach((item, index) => {
                        if (item == id) {
                            this.arrId.splice(index, 1)
                        }
                    })

                }
                //   console.log(this.arrId)
            },

            //         currentPage(e) {
            //   //当前页
            //   this.page = e;
            //   this.logLevel = false
            // //   console.log(this.arrId)
            //             this.list()
            // },
            list() {
                //     this.$axios.post(
                //    '/crm/acc/queryAllAcc',
                //    {apiToken:this.$store.state.usermsg.apiToken,
                //     isEdit:false,
                //     page_no: 1,
                //       size: 100000,
                //   }
                //  ).then(res=>{
                //    // console.log(res,111)
                // //    this.tokenInvalid(res)
                //    if(res.data.code ==200){
                //     this.length = res.data.data.length
                //      this.pageLength = Math.ceil(res.data.data.length)

                //    }
                //  })


                //获取所有合作
                this.$axios.post(
                    '/crm/query_all_acc',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        investorId: this.$route.query.id
                        // isEdit:false,
                        // page_no: this.page,
                        //   size: 10000,
                    }
                ).then(res => {
                    console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.resList = []
                        res.data.data.forEach(item => {
                            item.isShow = true

                            this.resList.push(item)
                        })
                        console.log(this.resList)
                        // this.resList.forEach(item=>{

                        //     this.arrId.forEach(e=>{
                        //         if(e==item.id){
                        //             item.deleted =true
                        //         }
                        //     })
                        // })

                    }
                })
            },
            adduser() {
                this.adduserShow = true
            },
            queryInvestor() {

                this.$axios
                    .post('/crm/inverstor/queryInvestor', {
                        apiToken: this.$store.state.usermsg.apiToken,
                        invId: this.$route.query.id
                    })
                    .then((res) => {
                        console.log(res);

                        if (res.data.code == 200) {
                            this.res = res.data.data
                            this.partner = this.res.partner
                            this.interim = this.res.interim
                        }
                    });
            },
            edit_() {
                this.edit = false
            },
            saveBtn_() {


                this.$axios.post(
                    '/crm/inverstor/editInv',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        address: this.res.address ? this.res.address : '',
                        invId: this.$route.query.id,

                        contactor: this.res.contactor ? this.res.contactor : '',
                        simpleName: this.res.simpleName ? this.res.simpleName : '',
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {

                        this.edit = true
                    }
                })


            },
            editBtn() {
                this.edit2 = false
            },
            saveBtn() {

                console.log(this.res.contactor)
                this.$axios.post(
                    '/crm/inverstor/editInv',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        phone: this.res.phone ? this.res.phone : '',
                        mail: this.res.mail ? this.res.mail : '',
                        contactor: this.res.contactor ? this.res.contactor : '',
                        simpleName: this.res.simpleName ? this.res.simpleName : '',
                        invId: this.$route.query.id,
                        interim: this.interim,
                        partner: this.partner ? 1 : 0
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.queryInvestor()
                        this.edit2 = true
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true,
                        })
                            .then(() => { })
                            .catch(() => { });
                    }
                })

            },
            Investor() {
                //点击分析

                let arrId = this.$route.query.id
                if (this.userList.length > 0) {
                    window.open('_blank').location.href = `/crm/analysis/Fitting?InvestorId=${arrId}`
                } else {
                    this.$alert('暂无账户进行分析', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true,
                    })
                        .then(() => { })
                        .catch(() => { });
                }
            },

            prev() {
                this.$router.go(-1)
            },
            handleAvatarSuccess(res, file) {
                //上传logo
                // console.log(res);
                if (res.code == 200) {
                    // this.$message.success(res.message);
                    // this.imageUrl = URL.createObjectURL(file.raw);
                    // this.imgPath = res.data.filePath;
                    this.$axios.post(
                        '/crm/inverstor/editInv',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            logo: res.data.filePath,
                            // phone: '',
                            // contactor: '',
                            // simpleName: '',
                            invId: this.$route.query.id
                        }
                    )
                        .then((res) => {
                            // console.log(res);
                            if (res.data.code == 200) {

                                this.queryInvestor()

                                //   crmNav.methods.getAuthInfo();
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true,
                                })
                                    .then(() => { })
                                    .catch(() => { });
                            }
                        });
                } else {
                    this.$message.error(res.message);
                }
            },
            handleAvatarSuccess__t(res, file) {
                //上传尽调表
                // console.log(res,123);
                if (res.code == 200) {

                    this.$axios.post(
                        '/crm/inverstor/editInv',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,

                            investorInfoFile: res.data.filePath,
                            invId: this.$route.query.id
                        }
                    ).then(res => {
                        // console.log(res)
                        if (res.data.code == 200) {
                            this.$alert('上传成功', {
                                confirmButtonText: '确定',
                                type: 'success',
                                center: true
                            }).then(() => { this.queryInvestor() }
                            ).catch(() => { this.queryInvestor() });


                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }
                            ).catch(() => { });
                        }
                    })
                }
            },
            delBtn__t() {
                //移除文件
                this.path__t = ''
            },

        },
    };
</script>


// WEBPACK FOOTER //
// src/view/crm/InvestorManage/details/index.vue